import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { ErrorMessage, FormikContext } from 'formik'
import { withStyles } from '@mui/styles'
import clsx from 'clsx'

import config from '@/config'
import lang from 'lang'

class EmailInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.value || '',
      isInvalid: false,
      errorMessage: null,
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onInputBlur = this.onInputBlur.bind(this)
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.state.value) {
      this.setState({ value: newProps.value })
    }

    const { errorMessage: newErrorMessage } = newProps

    if (newErrorMessage !== undefined) {
      const errorMessage = newErrorMessage || ''
      const isInvalid = !isEmpty(newErrorMessage)
      this.setState({ isInvalid, errorMessage })
    }
  }

  validateValue(value) {
    const { required } = this.props

    if (required && !value.trim()) {
      return { isInvalid: true, errorMessage: lang.emptyRequiredFieldErrorMessage }
    } else if (value && !config.emailCheck.test(value)) {
      return { isInvalid: true, errorMessage: lang.emailInvalidText }
    } else {
      return { isInvalid: false, errorMessage: null }
    }
  }

  onInputChange(event) {
    const { onChange, name } = this.props
    const { target: { value } } = event

    this.setState({ value, isInvalid: false, errorMessage: '' }, () => {
      const { isInvalid, errorMessage } = this.validateValue(value)

      if (isInvalid) {
        this.setState({ isInvalid, errorMessage })
      }
      onChange && onChange(value, name, event)
    })
  }

  onInputBlur(event) {
    const { target: { value } } = event
    const { name, onBlur } = this.props

    const { isInvalid, errorMessage } = this.validateValue(value)

    if (isInvalid) {
      return this.setState({ isInvalid, errorMessage })
    }

    onBlur && onBlur(value, name, event)
  }

  render() {
    const { isInvalid, errorMessage, value } = this.state
    const { name, label, customClass, useFormik, autoFocus, readOnly, disabled, className, classes, dataQsId } = this.props

    const field = (useFormik === undefined || useFormik) && this.context ? this.context.getFieldProps(name) : null

    let errorElm = null

    if (field) {
      errorElm = <ErrorMessage name={name} className={classes.error} component="div" render={() => <div className={classes.error}>{errorMessage}</div>} />
    } else {
      errorElm = isInvalid
        ? <div className={classes.error}>{errorMessage}</div>
        : null
    }

    return (
      <div className={clsx(classes.container, customClass, className)} data-qs-id={dataQsId}>
        <label className={clsx(classes.label, readOnly ? styles.textReadOnly : '')}>{label}</label>
        <input
          name={name}
          type='text'
          className={clsx(classes.input, isInvalid ? classes.invalid : null)}
          onChange={this.onInputChange}
          autoFocus={autoFocus}
          disabled={disabled}
          readOnly={readOnly}
          value={field ? (field.value ?? '') : value}
          onBlur={this.onInputBlur}
          {...field}
        />
        {errorElm}
      </div>
    )
  }
}

EmailInput.contextType = FormikContext

EmailInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  useFormik: PropTypes.bool,
  customClass: PropTypes.string,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  dataQsId: PropTypes.string.isRequired,
}

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  label: {
    color: theme.black,
    fontSize: 13,
    marginBottom: 10,
  },
  input: {
    outline: 'none',
    background: theme.backgroundColor,
    border: `1px solid ${theme.borderColor}`,
    borderRadius: 4,
    height: 45,
    paddingLeft: 15,
    '&:focus': {
      background: theme.white,
      borderColor: theme.activeInputBorder,
    },
    '&:disabled': {
      background: theme.backgroundColorDisabled,
    },
    '&:read-only': {
      color: theme.disabledColor,
    },
  },
  invalid: {
    borderColor: theme.error,
  },
  error: {
    fontSize: 12,
    color: theme.error,
    marginTop: 10,
  },
})

export default withStyles(styles)(EmailInput)
